import { createApi } from '@reduxjs/toolkit/query/react';
import { Question } from '../types';
import baseQuery from '../../../baseQuery/basePlatformQuery';

const BASE_URL = '/api/v1/platform/question-answers'

export const questionApi = createApi({
    reducerPath: 'questionApi',
    baseQuery,
    tagTypes: ['question'],
    endpoints: (builder) => ({
        getQuestions: builder.query<Array<Question>, void>({
            query: () => ({
                url: `${BASE_URL}/all`,
                method: 'GET',
            }),
            providesTags: ['question'],
        }),
    }),
});

export const { useGetQuestionsQuery } = questionApi;